import { get } from 'lodash';
import { cancel, fork, Pattern, take } from 'redux-saga/effects';

/**
 * Forks a saga on each action dispatched to the Store that matches pattern,
 * and automatically cancels any previous saga task started previously if `payload.meta.takeLatest: true`
 *
 * https://redux-saga.js.org/docs/api/#takelatestpattern-saga-args
 */
const takeConditional = <P extends Pattern, Fn extends (...args: any[]) => any>(pattern: P, worker: Fn, ...args: any) =>
  fork(function* every() {
    const lastTasks: { [key: string]: any } = {};
    while (true) {
      // @ts-ignore
      const action = yield take(pattern);
      const takeLatest = get(action, 'payload.meta.takeLatest');
      const key = get(action, 'payload.resource.key');
      const lastTask = lastTasks[key];
      if (takeLatest && lastTask) {
        yield cancel(lastTask); // cancel is no-op if the task has already terminated
      }
      // @ts-ignore
      const task = yield fork(worker, ...args.concat(action));
      if (takeLatest) {
        lastTasks[key] = task;
      }
    }
  });

export default takeConditional;
